export default "__VITE_ASSET__D_CuwX1e__"